import React from "react";
import { Grid, Paper, Typography, Box, Stack } from "@mui/material";

// Sub-component for individual fields
const Field = ({ label, value }) => (
    <Box>
        <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
            {label}
        </Typography>
        <Typography variant="body2" fontWeight={500}>
            {value || "-"}
        </Typography>
    </Box>
);

// Sub-component for sections using Grid layout
const InfoSection = ({ title, children }) => (
    <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
            {title}
        </Typography>
        <Grid container spacing={3}>
            {React.Children.map(children, (child) => (
                <Grid item xs={12} sm={6} md={4}>
                    {child}
                </Grid>
            ))}
        </Grid>
    </Paper>
);

const OverviewTab = ({ change }) => {
    if (!change) return null;

    return (
        <Stack spacing={3}>
            <InfoSection title="Change Information">
                <Field label="Change ID" value={change.changeNumber} />
                <Field label="Title" value={change.title} />
                <Field label="Change Type" value={change.changeTypeName} />
                <Field label="Category" value={change.categoryName} />
                <Field label="Priority" value={change.priorityName} />
                <Field label="Risk" value={change.riskName} />
                <Field label="Requested By" value={change.requestedBy} />
            </InfoSection>

            <InfoSection title="Impact Information">
                <Field label="Affected Service" value={change.affectedServiceName} />
                <Field label="Affected Asset" value={change.affectedAssetName} />
                <Field label="Configuration Item" value={change.configurationItemName} />
                <Field label="Department" value={change.departmentName} />
                <Field label="Business Impact" value={change.businessImpact} />
            </InfoSection>

            
            <InfoSection title="Scheduling">
                <Field label="Planned Start" value={formatToLocalTime(change.plannedStartDate)} />
                <Field label="Planned End" value={formatToLocalTime(change.plannedEndDate)} />
                <Field label="Maintenance Window" value={change.maintenanceWindowName} />               
            </InfoSection>

            <InfoSection title="Implementation">
                <Field label="Implementation Plan" value={change.implementationPlan} />
                <Field label="Testing Plan" value={change.testingPlan} />
                <Field label="Rollback / Backout Plan" value={change.rollbackPlan} />
               
            </InfoSection>
        </Stack>
    );
};

// Helper function to format ISO strings to a readable local date/time string
const formatToLocalTime = (isoString) => {
  if (!isoString) return "-";
  try {
    const date = new Date(isoString);
    // Returns format like: "31/8/2026, 9:25:00 pm" (matches user's system locale)
    return date.toLocaleString(); 
  } catch (e) {
    return isoString;
  }
};

export default OverviewTab;
